import React from 'react';
import Icon, { IconName } from '../Icon';
import { useTranslation } from '../../i18n';
import { TabType } from '../../hooks/useNavigation';
import { useRunningTimerCount } from '../../contexts/TimerContext';
import './BottomNav.css';

interface BottomNavProps {
  activeTab: TabType | null;
  onTabChange: (tab: TabType) => void;
}

const TABS: Array<{ tab: TabType; icon: IconName }> = [
  { tab: 'home', icon: 'calendar' },
  { tab: 'goals', icon: 'goal' },
  { tab: 'time', icon: 'clock' },
  { tab: 'progress', icon: 'chart' },
];

/**
 * The narrow-screen tab bar (Faz 23, T-180): Bugün, Hedefler, Zaman, İlerleme; no "+" (a goal
 * is created from Hedefler). A green dot on Zaman while a timer runs.
 */
const BottomNav: React.FC<BottomNavProps> = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation();
  const runningCount = useRunningTimerCount();
  return (
    <nav className="bottom-nav" aria-label={t('navigation.mainNav')}>
      {TABS.map(({ tab, icon }) => {
        const isActive = activeTab === tab;
        const live = tab === 'time' && runningCount > 0;
        return (
          <button
            key={tab}
            type="button"
            className={`bottom-nav__item${isActive ? ' is-active' : ''}`}
            onClick={() => onTabChange(tab)}
            aria-current={isActive ? 'page' : undefined}
            aria-label={live ? `${t(`navigation.short.${tab}`)}, ${t('home.continue.runningNow')}` : undefined}
          >
            <span className="bottom-nav__icon-wrap">
              <Icon name={icon} className="bottom-nav__icon" />
              {live && <span className="bottom-nav__live" aria-hidden="true" />}
            </span>
            <span className="bottom-nav__label">{t(`navigation.short.${tab}`)}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
